import { render } from "./ChallengeModal.vue?vue&type=template&id=3e312ce5&scoped=true"
import script from "./ChallengeModal.vue?vue&type=script&lang=js"
export * from "./ChallengeModal.vue?vue&type=script&lang=js"

import "./ChallengeModal.vue?vue&type=style&index=0&id=3e312ce5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e312ce5"]])

export default __exports__